module.exports = __webpack_public_path__ + "media/laws-bg2-1920@2x.dceb744e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/laws-bg2-1920@2x.jpg
// module id = 1351
// module chunks = 57